import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportFuelConsumptionByRouteLazy
} from "@containers/reports/readyReports/reportFuelConsumption/ReportFuelConsumptionByRoute.lazy";


const ReportFuelConsumptionByRoutePage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >

                <ReportFuelConsumptionByRouteLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportFuelConsumptionByRoutePage;